import { db, DashboardSettings } from '../db';

export const DEFAULT_DASHBOARD_SETTINGS: DashboardSettings = {
  id: 'dashboard',
  greenDays: 3,
  yellowDays: 7,
  cadenceDays: 7,
  greenColor: '#27ae60',
  yellowColor: '#f39c12',
  redColor: '#e74c3c',
};

/**
 * Retrieves the dashboard settings from IndexedDB.
 * Returns defaults if no settings have been saved yet.
 */
export async function getDashboardSettings(): Promise<DashboardSettings> {
  const settings = await db.dashboardSettings.get('dashboard');
  if (!settings) {
    return { ...DEFAULT_DASHBOARD_SETTINGS };
  }
  return settings;
}

/**
 * Merges the given partial updates into the existing dashboard settings
 * and persists them to IndexedDB.
 */
export async function updateDashboardSettings(
  updates: Partial<Omit<DashboardSettings, 'id'>>
): Promise<void> {
  const current = await getDashboardSettings();
  const next: DashboardSettings = {
    ...current,
    ...updates,
    id: 'dashboard',
  };
  await db.dashboardSettings.put(next);
}
